export const GET_ALL_POST='GET_ALL_POST';
export const ADD_POST=" ADD_POST";
export const UPDATE_GET_ALL_POST="UPDATE_GET_ALL_POST";
export const ADD_COMMENT_TO_POST="ADD_COMMENT_TO_POST";
export const SHOW_SINGLE_POSTE_ALL_COMMENT='SHOW_SINGLE_POSTE_ALL_COMMENT';
export const SHOW_COMMENT_TYPE_INPUT="SHOW_COMMENT_TYPE_INPUT";
export const DELETE_COMMENT="DELETE_COMMENT";
export const DELETE_POST="DELETE_POST";
export const SINGLE_LIKE_ON_POST="SINGLE_LIKE_ON_POST";